import * as actions from './actionTypes';
import { Tariff } from 'api';

export interface ITariffStore {
	tariffs: Tariff[];
	tariff?: Tariff;
	isLoading: boolean;
	error?: string;
}

export const INITIAL_STATE: ITariffStore = {
	tariffs: [],
	tariff: undefined,
	isLoading: false,
	error: '',
};

const OfferSearchData = (
	state = INITIAL_STATE,
	action: { type: string; payload: any }
) => {
	switch (action.type) {
		case actions.GET_TARIFF:
		case actions.GET_TARIFFS:
			state = {
				...state,
				isLoading: true,
			};
			break;

		case actions.SET_TARIFF:
			state = {
				...state,
				tariff: { ...action.payload },
				isLoading: false,
			};
			break;

		case actions.SET_TARIFFS:
			state = {
				...state,
				tariffs: [...action.payload],
				isLoading: false,
			};
			break;

		case actions.TARIFF_RESET_ALL:
			state = { ...INITIAL_STATE };
			break;

		case actions.TARIFF_ERROR:
			state = {
				...state,
				error: action.payload,
				isLoading: false,
			};
			break;

		case actions.TARIFF_CLEAR_ERROR:
			state = {
				...state,
				error: '',
			};
			break;

		default:
			state = { ...state };
			break;
	}
	return state;
};

export default OfferSearchData;
